<template>
    <header
        class="shadow-sm h-20 flex items-center bb-header-background"
        v-if="settings"
    >
        <img
            :src="settings.header.logo"
            class="mx-auto max-h-16 max-w-9 md:max-w-sm"
        />
        <PermissionCheck permission="drg.app.header.sidebar.view">
            <Slide right :closeOnNavigation="true">
                <div v-for="page in this.pages" :key="page.id">
                    <router-link :to="page.path">{{
                        page.name
                    }}</router-link>
                </div>
                <div>
                    <!--<SwitchLang :initLang="initLang" :options="options" />-->
                </div>
            </Slide>
        </PermissionCheck>
    </header>
</template>

<script>
import { Slide } from "vue-burger-menu";
//import SwitchLang from "vue-switch-lang";
import { mapGetters } from "vuex";
import PermissionCheck from "./PermissionCheck";

export default {
    name: "Header",
    computed: mapGetters({ settings: "app/settings", pages: "app/sidebar"}),
    components: {
        PermissionCheck,
        Slide
    }
};
</script>
<style>
.bm-menu {
    background-color: var(--header-sidebar-background-color);
}
.bm-cross,
.bm-item-list > * > span {
    background-color: var(--header-sidebar-color);
}
.bm-burger-button {
    top: 25px !important;
    right: 25px !important;
}
.bm-menu {

    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.bb-header-background {
    background: var(--header-background);

}
.bm-burger-bars {
    background-color: var(--header-sidebar-hamburger-color);
}

.multiselect__option--selected {
    background-color: red;
}
.bm-menu {
    background: var(--header-sidebar-background-color);
}

.bm-item-list {
    color: var(--header-sidebar-color);
}
.bm-cross-button.cross-style .bm-cross {
    background-color: var(--header-sidebar-color);
}
.multiselect__option--highlight {
    background-color: green;
    background: green;
}
.max-w-9 {
    max-width: 9rem;
}
</style>
